import classNames from 'classnames';
import React from 'react';
import { StatesButtonStates, StatesButton as TPAButton, Spinner, PaddingModes, HoverStyles } from 'wix-ui-tpa/cssVars';
import { ForcedState, useForcedState } from '../../../../contexts/forced-state-context';
import { useForm } from '../../../../contexts/form-context';
import { FadeOut } from '../fade-out';
import { useSubmitButton } from '../use-submit-button';
import { getCurrentStep } from '../utils';
import { ErrorMessageWUT } from './error-message-wut';
import { NextButton } from './next-button';
import { PreviousButton } from './previous-button';
import { classes } from './submit-button-wut.st.css';
import { ThankYouMessageWUT } from './thank-you-message-wut';
const InProgressLoader = _ref => {
  let {
    submitText
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: classes.hiddenText
  }, submitText), /*#__PURE__*/React.createElement(Spinner, {
    className: classes.spinner
  }));
};
const Submit = _ref2 => {
  let {
    onClick,
    disabled,
    submitText,
    hasSteps,
    inProgress
  } = _ref2;
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.SUBMIT_BUTTON_HOVER);
  return /*#__PURE__*/React.createElement(TPAButton, {
    className: classNames(classes.button, {
      [classes.buttonNoSteps]: !hasSteps,
      [classes.buttonWithSteps]: hasSteps,
      [classes.hover]: hover,
      [classes.navigationButtons]: hasSteps,
      [classes.inProgress]: inProgress
    }),
    hoverStyle: HoverStyles.underline,
    upgrade: true,
    wrapContent: true,
    onClick: onClick,
    disabled: disabled,
    state: inProgress ? StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE,
    inProgressContent: /*#__PURE__*/React.createElement(InProgressLoader, {
      submitText: submitText
    }),
    idleContent: submitText,
    paddingMode: PaddingModes.explicitPaddings,
    "data-hook": "submit-button"
  });
};
export const SubmitButtonWUT = _ref3 => {
  let {
    submitText,
    text,
    id,
    thankYouMessageText,
    thankYouMessageDuration,
    externalUrl,
    externalUrlTarget,
    submitAction,
    forceThankYouMessage,
    previousText,
    nextText,
    FieldLayout
  } = _ref3;
  const form = useForm();
  const {
    hasSteps,
    stepNumber,
    isLastStep
  } = getCurrentStep(form, id);
  const {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    isThankYouMessageVisible,
    thankYouMessage,
    errorMessage,
    submitButtonText
  } = useSubmitButton({
    fieldId: id,
    thankYouMessageDuration,
    thankYouMessageText,
    forceThankYouMessage,
    externalUrl,
    externalUrlTarget,
    submitAction,
    text,
    submitText
  });
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => null,
    renderInput: () => /*#__PURE__*/React.createElement("div", {
      className: classNames({
        [classes.navigationContainer]: hasSteps,
        [classes.rowSpacing]: hasSteps && stepNumber !== 0
      })
    }, hasSteps && stepNumber !== 0 && /*#__PURE__*/React.createElement(PreviousButton, {
      previousText: previousText,
      className: classes.navigationButtons
    }), hasSteps && !isLastStep ? /*#__PURE__*/React.createElement(NextButton, {
      nextText: nextText,
      className: classes.navigationButtons
    }) : /*#__PURE__*/React.createElement(Submit, {
      onClick: handleSubmitClick,
      disabled: isDisabled,
      submitText: submitButtonText,
      hasSteps: hasSteps,
      inProgress: isInProgress
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FadeOut, {
      animate: isThankYouMessageVisible
    }, /*#__PURE__*/React.createElement(ThankYouMessageWUT, {
      messageText: thankYouMessage
    })), errorMessage && /*#__PURE__*/React.createElement(ErrorMessageWUT, {
      errorMessage: errorMessage
    }))
  });
};
//# sourceMappingURL=submit-button-wut.js.map